import { useModules } from '@entities/common';
import type React from 'react';
import { Link } from 'react-router-dom';

import Add from '@mui/icons-material/Add';

import * as st from './styles.module.scss';

export const ButtonAssign: React.FC = () => {
	const { moduleByType } = useModules();

	const coachModule = moduleByType('coaches');

	return coachModule ? (
		<Link to={`/coaches/${coachModule.code}`} className={st.assign}>
			<div className={st.assign__text}>Записаться на консультацию</div>
			<div className={st.assign__icon}>
				<Add />
			</div>
		</Link>
	) : (
		<></>
	);
};
